export default function NavigationHandler({
  node,
  setIsRebuttals,
  setIsScripts,
  setCurrentScript,
  setCurrentRebuttal,
}: {
  node: HTMLElement
  setIsRebuttals: (_value: boolean) => void
  setIsScripts: (_value: boolean) => void
  setCurrentScript: (_value: number) => void
  setCurrentRebuttal: (_value: number) => void
}) {
  const navigationButton = node.querySelectorAll(
    '.nav-button',
  ) as NodeListOf<HTMLElement>

  const navigationHandler = (e: Event) => {
    const target = e.currentTarget as HTMLElement
    if (target.dataset.navigate) {
      const [scriptType, scriptNumber] = target.dataset.navigate.split(':')
      switch (scriptType.toLowerCase()) {
        case 'script':
          setIsRebuttals(false)
          setIsScripts(true)
          setCurrentScript(parseInt(scriptNumber))
          break
        case 'rebuttal':
          setIsRebuttals(true)
          setIsScripts(false)
          setCurrentRebuttal(parseInt(scriptNumber))
          break
      }
    }
  }
  navigationButton.forEach((el) =>
    el.addEventListener('click', navigationHandler),
  )

  return () => {
    navigationButton.forEach((el) =>
      el.removeEventListener('click', navigationHandler),
    )
  }
}
